import axios from "@util/axios";
import projectConfig from "@projectConfig";
import { store } from "../../../appRedux/store/Store";
import { v4 } from "uuid";

const { hostCloud } = projectConfig.api;

// THIS FILE IF FOR PROPERLY WRITTEN BOARDS REQUESTS. PLEASE KEEP THIS FILE CLEAN

export const deleteBoard = async (boardId) => {
   const params = { boardId };
   return axios({
      method: "DELETE",
      url: `${hostCloud}/boards`,
      headers: { "Content-Type": "application/json" },
      params,
   });
};

export const copyBoard = async (boardId) => {
   const params = { boardId };
   return axios({
      method: "POST",
      url: `${hostCloud}/boards/copy-board`,
      headers: { "Content-Type": "application/json" },
      params,
   });
};

export const editBoard = async (board) => {
   return axios({
      method: "PUT",
      url: `${hostCloud}/boards`,
      headers: {
         "Content-Type": "application/json",
         Accept: "*/*",
      },
      data: board,
   });
};

export const addBoard = async (boardNameTranslations) => {
   //TODO: Change this after backend fixes translations
   const translationKey = "board." + v4();

   return axios({
      method: "POST",
      url: `${hostCloud}/boards`,
      headers: {
         Accept: "*/*",
      },
      data: {
         members: [
            {
               member: {
                  id: store?.getState()?.auth?.authUser?.id,
               },
               type: "OWNER",
            },
         ],
         //TODO: Change this after backend fixes translations
         name: translationKey,
         sheets: [
            {
               name: `sheet.${Math.floor(Math.random() * 100000) + 1}-${
                  Math.floor(Math.random() * 100000) + 1
               }`,
               priority: 0,
               widgets: [],
            },
         ],
         translations: [
            { key: translationKey, category: "board.name", values: boardNameTranslations },
         ],
      },
   });
};

export const getAllBoards = async () => {
   return axios({
      method: "GET",
      url: `${hostCloud}/boards/all`,
      headers: { "Content-Type": "application/json" },
   });
};

export const updateBoardOrder = async (boardId, boardOrder) => {
   const data = {
      boardsOrder: [{ boardId, boardOrder }],
   };
   return axios({
      method: "PUT",
      url: `${hostCloud}/boards/order`,
      headers: { "Content-Type": "application/json" },
      data,
   });
};

export const updatePublicUserBoard = async (publicUserId, boardId, order, showInMainNav) => {
   const params = {
      publicUserId,
      boardId,
      order,
      showInMainNav,
   };

   return axios({
      method: "put",
      url: `${hostCloud}/public-user/board`,
      headers: { "Content-Type": "application/json" },
      params: params,
   });
};

export const getBoard = async (id) => {
   return axios({
      method: "get",
      url: `${hostCloud}/boards/details?` + "id=" + id,
      headers: {
         Accept: "*/*",
      },
   });
};

export const saveBoard = async (board) => {
   // TO FIX, find why sometimes transkationKey is null in widgetList, then remove this line
   const boardTranslationsWithKey = board?.translations?.filter((transl) => transl.key);
   return axios({
      method: "put",
      url: `${hostCloud}/boards`,
      headers: {
         ContentType: "application/json;charset=UTF-8",
         Accept: "*/*",
      },
      data: {
         id: board.id,
         name: board.name,
         sheets: board.sheets,
         members: board.members,
         deleted: false,
         backgroundColourHex: board.backgroundColourHex,
         tabsAreBottomOnMobile: board.tabsAreBottomOnMobile,
         connections: board.connections,
         isMobileOnly: board.isMobileOnly,
         mobileKey: board.mobileKey,
         translations: boardTranslationsWithKey ? boardTranslationsWithKey : board.translations,
      },
   });
};

export const shareBoard = async (boardId, membersId, memberType, showInMainNav) => {
   return axios({
      method: "post",
      url: `${hostCloud}/boards/sharing/member/share`,
      headers: { "Content-Type": "application/json" },
      data: {
         boardId: boardId,
         newMembersIds: membersId,
         memberType: memberType,
         showInMainNav: showInMainNav,
      },
   });
};

export const removeBoardMember = async (memberId, boardId) => {
   return axios({
      method: "delete",
      url: `${hostCloud}/boards/sharing/member/remove?boardId=${boardId}&memberId=${memberId}`,
      headers: { "Content-Type": "application/json" },
   });
};

export const updateBoardMemberRole = async (memberId, boardId, role, showInMainNav) => {
   const params = {
      boardMemberId: memberId,
      boardId,
      role,
      showInMainNav,
   };

   return axios({
      method: "put",
      url: `${hostCloud}/boards/sharing/member/update`,
      headers: { "Content-Type": "application/json" },
      params: params,
   });
};
export const updateBoardHiddenOption = async (boardId, hidden) => {
   const params = {
      boardId,
      hidden,
   };

   return axios({
      method: "put",
      url: `${hostCloud}/boards/hidden`,
      headers: { "Content-Type": "application/json" },
      params,
   });
};

export const shareBoardWithGroup = async (
   boardId,
   role,
   group,
   showInMainNav,
   isReferenceGroup,
) => {
   const mainNav = showInMainNav ? showInMainNav : false;
   return axios({
      method: "post",
      url: `${hostCloud}/boards/sharing/member-group/share?boardId=${boardId}&role=${role}&showInMainNav=${mainNav}&isReferenceGroup=${isReferenceGroup}`,
      headers: {
         "Content-Type": "application/json",
      },
      data: {
         companyOldId: group.companyOldId,
         id: group.id,
         mainPageUrl: group.mainPageUrl,
         name: group.name,
         oldId: group.oldId,
      },
   });
};
export const updateSharedBoardWithGroup = async (
   boardId,
   boardGroupId,
   role,
   showInMainNav,
   isReferenceGroup,
) => {
   return axios({
      method: "put",
      url: `${hostCloud}/boards/sharing/member-group/update?boardId=${boardId}&boardGroupId=${boardGroupId}&role=${role}&showInMainNav=${showInMainNav}&isReferenceGroup=${isReferenceGroup}`,
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const removeShareBoardWithGroup = async (boardId, boardGroupId, role) => {
   return axios({
      method: "delete",
      url: `${hostCloud}/boards/sharing/member-group/remove?boardId=${boardId}&boardGroupId=${boardGroupId}&role=${role}`,
      headers: { "Content-Type": "application/json" },
   });
};
